module.exports = __webpack_public_path__ + "img/1F1F3-1F1EE.1f4af32e.svg";